export default "__VITE_ASSET__BZ41joAF__"